import { useQuery } from '@tanstack/react-query'
import getConfig from '../../worker/fnx/getConfig'
import { useAdmin } from './admin'

export function useConfig() {
  const adminConfig = useAdmin()
  return useQuery(['config'], async () => getConfig(adminConfig)).data!
}
